import { Spinner } from '@crm/ui';
import { useEffect, useRef } from 'react';
import { useAdvanceWizard } from '../api';

/**
 * Tipo de estabelecimento, CNPJ, nome fantasia e razao social ja foram
 * coletados na tela inicial do cadastro (`company-lead-form.tsx`, so pra
 * quem escolheu "Tenho um estabelecimento") - nao tem mais o que perguntar
 * aqui de novo. Este passo so fecha `COMPANY_DATA` sozinho e segue.
 */
export function CompanyDetailsStep({ onDone }: { onDone: () => void }) {
  const advance = useAdvanceWizard();
  const disparado = useRef(false);

  useEffect(() => {
    if (disparado.current) return;
    disparado.current = true;
    advance.mutateAsync({ step: 'COMPANY_DATA' }).then(onDone);
  }, [onDone, advance.mutateAsync]);

  return (
    <div className="flex justify-center py-8">
      <Spinner className="h-6 w-6 text-muted-foreground" />
    </div>
  );
}
